import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendJoinCommunityRequestMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SendJoinCommunityRequestMutation = { __typename?: 'Mutation', sendJoinRequest?: { __typename?: 'JoinRequest', id: string } | null };


export const SendJoinCommunityRequestDocument = gql`
    mutation SendJoinCommunityRequest($id: ID!) {
  sendJoinRequest(data: {communityId: $id}) {
    id
  }
}
    `;
export type SendJoinCommunityRequestMutationFn = Apollo.MutationFunction<SendJoinCommunityRequestMutation, SendJoinCommunityRequestMutationVariables>;

/**
 * __useSendJoinCommunityRequestMutation__
 *
 * To run a mutation, you first call `useSendJoinCommunityRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendJoinCommunityRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendJoinCommunityRequestMutation, { data, loading, error }] = useSendJoinCommunityRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendJoinCommunityRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendJoinCommunityRequestMutation, SendJoinCommunityRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendJoinCommunityRequestMutation, SendJoinCommunityRequestMutationVariables>(SendJoinCommunityRequestDocument, options);
      }
export type SendJoinCommunityRequestMutationHookResult = ReturnType<typeof useSendJoinCommunityRequestMutation>;
export type SendJoinCommunityRequestMutationResult = Apollo.MutationResult<SendJoinCommunityRequestMutation>;
export type SendJoinCommunityRequestMutationOptions = Apollo.BaseMutationOptions<SendJoinCommunityRequestMutation, SendJoinCommunityRequestMutationVariables>;